// Next question prompt. Mirrors data-component="next-question-prompt".
// A gentle nudge for the rep: "A good next question" with a one-click
// jump into the right editor (routine / goals / profile / story).
//
// TODO(runtime): hydrate the suggested question from the priority
// engine (services/priority-engine.computeTopAction) once the HTTP read
// endpoint lands. Prompt text is a function of what's missing.
import type { ReactNode } from 'react';
import type { HorseProfile, EditorMode } from '../mockData.js';

export interface NextQuestionPromptProps {
  horse: HorseProfile;
  onEdit: (mode: EditorMode) => void;
  /** W32: real first name on a real session. Defaults to the design-preview customer. */
  customerFirstName?: string;
}

export function NextQuestionPrompt({ horse, onEdit, customerFirstName = 'Sarah' }: NextQuestionPromptProps): ReactNode {
  return (
    <section className="horse-prompt" data-component="next-question-prompt">
      <span className="eyebrow">A GOOD NEXT QUESTION</span>
      <h3>{horse.nextQuestion.prompt}</h3>
      <p>{horse.nextQuestion.helper}</p>
      <button className="outlined" type="button" onClick={() => onEdit(horse.nextQuestion.editor)}>
        Record {customerFirstName}'s answer <span>&#8599;</span>
      </button>
    </section>
  );
}
